import BaseObject from "../../../base/base_object";
import _ from "../../../utils/underscore";
import ServiceFactory from "../../service_factory";
import {TEMP_ACCOUNT_STATUS} from "../../../../../common/const/temp_account_status";

export default class TempAccountMessageRegulationHelper extends BaseObject {

    _serviceFactory: ServiceFactory = null;

    init(params) {
        super.init(params);
        params = params || {};
        if(!params.serviceFactory) {
            this.throwArgumentExpected('14', 'init', 'serviceFactory');
        }

        this._serviceFactory = params.serviceFactory;
    }

    _getDefaultAccountStatus() {
        const daysLeft = this._serviceFactory.userService().getAccountData().DaysToUploadDocument;
        if (_.isNullOrUndefined(daysLeft) || 0 > daysLeft)
            return {
                status: TEMP_ACCOUNT_STATUS.APPROVED
            };
        else {
            return {
                status: TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED,
                daysLeft: daysLeft
            };
        }
    }

    showTempAccountMessage(params) {
        const languageService = this._serviceFactory.languageService();
        const oauthService = this._serviceFactory.oAuth2Service();

        if (!oauthService.isAuthorized()) {
            return;
        }

        let tempAccountParams;
        if (!_.isNullOrUndefined(params.paramsFunc)) {
            tempAccountParams = params.paramsFunc.call();
        } else {
            tempAccountParams = Object.assign({}, this._getDefaultAccountStatus(), params);
        }
        if (tempAccountParams && tempAccountParams.status === TEMP_ACCOUNT_STATUS.APPROVED) {
            return;
        }

        this._serviceFactory.orbitComponentRenderService().showTempAccountPopup({
            status: tempAccountParams?.status,
            daysLeft: (tempAccountParams.hideDaysLeft || tempAccountParams?.status !== TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED) ? null : tempAccountParams.daysLeft,
            bodyText: languageService.translation(tempAccountParams?.messageKey),
            footerText: tempAccountParams?.footerMessageKey ? this._serviceFactory.languageService().translation(tempAccountParams?.footerMessageKey) : ""
        });
    }
}
